import { render, staticRenderFns } from "./VMobileNavAction.vue?vue&type=template&id=5fdc3d5a&"
import script from "./VMobileNavAction.vue?vue&type=script&lang=js&"
export * from "./VMobileNavAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports